import axios from "axios";
import Cookies from "universal-cookie";
import { backendUrl } from "../utils/url";

const cookies = new Cookies();

const api = axios.create({
  baseURL: backendUrl,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${cookies.get("jwt-auth")}`,
  },
});

export const getAllLessons = async () => {
  try {
    const res = await api.get("/lesson/all");
    return res;
  } catch (err) {
    return err.response;
  }
};

export const getPaginatedLessons = async (params) => {
  try {
    // فقط مقادیر تعریف‌شده را ارسال می‌کنیم تا query string تمیز باشد
    const queryParams = {};
    if (params.search) queryParams.search = params.search;
    if (params.grade) queryParams.grade = params.grade;
    if (params.book) queryParams.book = params.book;
    queryParams.page = params.page || 1;
    queryParams.limit = params.limit || 10;

    const res = await api.get("/lesson/paginated", { params: queryParams });

    // فقط data برگردانده شود
    return res.data;
  } catch (err) {
    return {
      lessons: [],
      total: 0,
      page: 1,
      totalPages: 1,
      message: err.response?.data?.message || "خطای شبکه",
      success: false,
    };
  }
};

export const addLesson = async (formData) => {
  try {
    const token = cookies.get("jwt-auth");
    const response = await axios.post(backendUrl + "/lesson/create", formData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (err) {
    console.log(err);
    return err.response;
  }
};

export const updateLesson = async (formData, id) => {
  try {
    const token = cookies.get("jwt-auth");
    const response = await axios.put(backendUrl + "/lesson/" + id, formData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (err) {
    return err.response;
  }
};

export const deleteLesson = async (id) => {
  try {
    const token = cookies.get("jwt-auth");
    const response = await axios.delete(backendUrl + "/lesson/" + id, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (err) {
    return err.response;
  }
};
